import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  showHomeLink?: boolean;
}

function Navbar({ showHomeLink = false }: NavbarProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-brand">
        {showHomeLink ? (
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            Mimadre Universe
          </Link>
        ) : (
          'Mimadre Universe'
        )}
      </div>
      <button
        className="burger-menu"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className={`nav-links ${isMenuOpen ? 'nav-open' : ''}`}>
        <Link to="/mimadre" onClick={() => setIsMenuOpen(false)}>Mimadre</Link>
        <Link to="/eos" onClick={() => setIsMenuOpen(false)}>EOS</Link>
        <Link to="/gaia" onClick={() => setIsMenuOpen(false)}>Gaia</Link>
        <Link to="/animacion-lectora" onClick={() => setIsMenuOpen(false)}>Animación Lectora</Link>
        <Link to="/firmas-y-ferias" onClick={() => setIsMenuOpen(false)}>Firmas y ferias</Link>
        <Link to="/club-lectura" onClick={() => setIsMenuOpen(false)}>Club de Lectura</Link>
      </div>
    </nav>
  );
}

export default Navbar;